import { render, staticRenderFns } from "./sabre.vue?vue&type=template&id=65f5099b&"
import script from "./sabre.vue?vue&type=script&lang=js&"
export * from "./sabre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports